import { STOREFRONT_THEME_PRESETS } from "./storefrontThemePresets";

const THEME_PREVIEW_IMAGES = {
  pantry: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&q=85",
};

const THEME_CONFIGS = {
  dawn: {
    themeName: "Dawn",
    fontFamily: "Inter",
    primaryColor: "#2563eb",
    secondaryColor: "#3b82f6",
    backgroundColor: "#ffffff",
    buttonColor: "#2563eb",
    textColor: "#1f2937",
    headingColor: "#111827",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  sense: {
    themeName: "Sense",
    fontFamily: "Poppins",
    primaryColor: "#7c3aed",
    secondaryColor: "#8b5cf6",
    backgroundColor: "#faf5ff",
    buttonColor: "#7c3aed",
    textColor: "#4c1d95",
    headingColor: "#581c87",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "glass",
  },
  craft: {
    themeName: "Craft",
    fontFamily: "Roboto",
    primaryColor: "#f59e0b",
    secondaryColor: "#fbbf24",
    backgroundColor: "#fffbeb",
    buttonColor: "#d97706",
    textColor: "#92400e",
    headingColor: "#78350f",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "border",
  },
  fresh: {
    themeName: "Fresh",
    fontFamily: "Nunito",
    primaryColor: "#059669",
    secondaryColor: "#10b981",
    backgroundColor: "#f0fdf4",
    buttonColor: "#059669",
    textColor: "#064e3b",
    headingColor: "#065f46",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  empire: {
    themeName: "Empire",
    fontFamily: "Montserrat",
    primaryColor: "#4f46e5",
    secondaryColor: "#818cf8",
    backgroundColor: "#0a0a1a",
    buttonColor: "#3730a3",
    textColor: "#e0e7ff",
    headingColor: "#c7d2fe",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  bloom: {
    themeName: "Bloom",
    fontFamily: "Poppins",
    primaryColor: "#e11d48",
    secondaryColor: "#fb7185",
    backgroundColor: "#fff1f2",
    buttonColor: "#be123c",
    textColor: "#881337",
    headingColor: "#9f1239",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "glass",
  },
  circuit: {
    themeName: "Circuit",
    fontFamily: "Inter",
    primaryColor: "#0ea5e9",
    secondaryColor: "#38bdf8",
    backgroundColor: "#f8fafc",
    buttonColor: "#0284c7",
    textColor: "#0c4a6e",
    headingColor: "#0369a1",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  slate: {
    themeName: "Slate",
    fontFamily: "Montserrat",
    primaryColor: "#60a5fa",
    secondaryColor: "#93c5fd",
    backgroundColor: "#1f2937",
    buttonColor: "#3b82f6",
    textColor: "#f3f4f6",
    headingColor: "#f9fafb",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  grove: {
    themeName: "Grove",
    fontFamily: "Nunito",
    primaryColor: "#65a30d",
    secondaryColor: "#84cc16",
    backgroundColor: "#f7fee7",
    buttonColor: "#4d7c0f",
    textColor: "#365314",
    headingColor: "#1a2e05",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "border",
  },
  tide: {
    themeName: "Tide",
    fontFamily: "Inter",
    primaryColor: "#0ea5e9",
    secondaryColor: "#38bdf8",
    backgroundColor: "#f0f9ff",
    buttonColor: "#0284c7",
    textColor: "#0c4a6e",
    headingColor: "#0369a1",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "glass",
  },
  aurora: {
    themeName: "Aurora",
    fontFamily: "Poppins",
    primaryColor: "#6366f1",
    secondaryColor: "#a5b4fc",
    backgroundColor: "#f8f8ff",
    buttonColor: "#4f46e5",
    textColor: "#3730a3",
    headingColor: "#312e81",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "shadow",
  },
  spice: {
    themeName: "Spice",
    fontFamily: "Roboto",
    primaryColor: "#dc2626",
    secondaryColor: "#ef4444",
    backgroundColor: "#fff5f5",
    buttonColor: "#b91c1c",
    textColor: "#7f1d1d",
    headingColor: "#991b1b",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "border",
  },
  regal: {
    themeName: "Regal",
    fontFamily: "Playfair Display",
    primaryColor: "#7c2d12",
    secondaryColor: "#b45309",
    backgroundColor: "#fffaf0",
    buttonColor: "#7c2d12",
    textColor: "#4a1d10",
    headingColor: "#7c2d12",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  meadow: {
    themeName: "Meadow",
    fontFamily: "DM Sans",
    primaryColor: "#166534",
    secondaryColor: "#16a34a",
    backgroundColor: "#f0fdf4",
    buttonColor: "#15803d",
    textColor: "#14532d",
    headingColor: "#14532d",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "glass",
  },
  pantry: {
    themeName: "Pantry",
    fontFamily: "Nunito",
    primaryColor: "#16a34a",
    secondaryColor: "#f59e0b",
    backgroundColor: "#fffbeb",
    buttonColor: "#15803d",
    textColor: "#14532d",
    headingColor: "#166534",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  atelier: {
    themeName: "Atelier",
    fontFamily: "Montserrat",
    primaryColor: "#be185d",
    secondaryColor: "#ec4899",
    backgroundColor: "#fff7fb",
    buttonColor: "#831843",
    textColor: "#500724",
    headingColor: "#831843",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "glass",
  },
  remedy: {
    themeName: "Remedy",
    fontFamily: "Inter",
    primaryColor: "#0f766e",
    secondaryColor: "#14b8a6",
    backgroundColor: "#f0fdfa",
    buttonColor: "#0f766e",
    textColor: "#134e4a",
    headingColor: "#115e59",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "shadow",
  },
  forge: {
    themeName: "Forge",
    fontFamily: "Montserrat",
    primaryColor: "#334155",
    secondaryColor: "#f59e0b",
    backgroundColor: "#f8fafc",
    buttonColor: "#1e293b",
    textColor: "#1e293b",
    headingColor: "#0f172a",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "border",
  },
  ovenly: {
    themeName: "Ovenly",
    fontFamily: "DM Sans",
    primaryColor: "#c2410c",
    secondaryColor: "#f59e0b",
    backgroundColor: "#fff7ed",
    buttonColor: "#9a3412",
    textColor: "#7c2d12",
    headingColor: "#9a3412",
    borderRadius: "12px",
    buttonStyle: "pill",
    cardStyle: "shadow",
  },
  harvest: {
    themeName: "Harvest",
    fontFamily: "Nunito",
    primaryColor: "#3f6212",
    secondaryColor: "#ca8a04",
    backgroundColor: "#fefce8",
    buttonColor: "#4d7c0f",
    textColor: "#365314",
    headingColor: "#365314",
    borderRadius: "12px",
    buttonStyle: "rounded",
    cardStyle: "border",
  },
};

const CATEGORY_THEME_RULES = [
  { themeId: "ovenly", keywords: ["bakery", "baker", "pastry", "cake", "dessert", "confectionery"] },
  { themeId: "pantry", keywords: ["grocery", "groceries", "supermarket", "kirana", "mart", "provision"] },
  { themeId: "atelier", keywords: ["fashion", "apparel", "clothing", "boutique", "textile", "garment"] },
  { themeId: "remedy", keywords: ["medical", "medicine", "pharmacy", "pharma", "clinic", "hospital"] },
  { themeId: "forge", keywords: ["manufacturing", "manufacturer", "factory", "industrial", "machinery", "tools"] },
  { themeId: "harvest", keywords: ["farm", "farms", "farming", "agriculture", "agri", "dairy", "poultry", "seeds"] },
  { themeId: "spice", keywords: ["restaurant", "food", "cafe", "beverage", "kitchen", "hotel"] },
  { themeId: "fresh", keywords: ["organic", "vegetable", "vegetables", "fruit", "fruits", "superfood"] },
  { themeId: "circuit", keywords: ["electronics", "electronic", "mobile", "computer", "tech", "gadget", "appliance"] },
  { themeId: "bloom", keywords: ["beauty", "cosmetic", "cosmetics", "salon", "spa", "skincare", "makeup"] },
  { themeId: "grove", keywords: ["health", "wellness", "fitness", "ayurveda", "supplement"] },
  { themeId: "sense", keywords: ["footwear", "style", "designer", "wardrobe"] },
  { themeId: "regal", keywords: ["jewelry", "jewellery", "luxury", "premium", "watch", "diamond", "gold"] },
  { themeId: "craft", keywords: ["craft", "handmade", "handicraft", "gift", "artisan", "home decor"] },
  { themeId: "aurora", keywords: ["creative", "design", "studio", "art", "photography", "agency"] },
  { themeId: "meadow", keywords: ["plant", "nursery", "garden", "florist", "botanical"] },
  { themeId: "tide", keywords: ["lifestyle", "home", "furniture", "decor", "living"] },
];

const normalize = (value) => String(value || "").toLowerCase().trim();

const getBusinessTextForMatching = (businessInput = "") => {
  if (typeof businessInput === "string") {
    return normalize(businessInput);
  }

  const source = businessInput || {};
  return normalize(
    [
      source.businessCategory,
      source.businessOtherCategory,
      source.businessType,
      source.category,
      source.storeCategory,
      source.businessName,
      source.businessDescription,
    ]
      .filter(Boolean)
      .join(" "),
  );
};

export const shouldUseBusinessDefaultTheme = (theme = {}) => {
  if (!theme) return true;

  const themeId = normalize(theme.themeId);
  if (themeId) return false;

  const themeName = normalize(theme.themeName);
  return !themeName || themeName === "modern indigo";
};

export const getRecommendedThemeIdByBusinessType = (businessInput = "") => {
  const normalizedCategory = getBusinessTextForMatching(businessInput);
  if (!normalizedCategory) return "dawn";

  const match = CATEGORY_THEME_RULES.find((rule) =>
    rule.keywords.some((keyword) => normalizedCategory.includes(keyword)),
  );

  return match?.themeId || "dawn";
};

export const getBusinessTypeDefaultTheme = (businessCategory = "") => {
  const themeId = getRecommendedThemeIdByBusinessType(businessCategory);
  const config = THEME_CONFIGS[themeId] || THEME_CONFIGS.dawn;
  const preset = STOREFRONT_THEME_PRESETS[themeId] || {};

  return {
    ...config,
    themeId,
    themePreviewImage: THEME_PREVIEW_IMAGES[themeId] || "",
    heroEyebrow: "",
    heroTitle: "",
    heroSubtitle: "",
    primaryCtaText: "",
    secondaryCtaText: "",
    hideBanner: typeof preset.hideBanner === "boolean" ? preset.hideBanner : true,
    heroVariant: preset.heroVariant || "classic",
    productVariant: preset.productVariant || "grid",
    layoutPreset: {
      heroVariant: preset.heroVariant || "classic",
      productVariant: preset.productVariant || "grid",
      sectionDensity: "balanced",
    },
  };
};